//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton";
import AQInput from "@/components/Generics/AQInput/AQInput";
import AQCard from "@/components/Generics/AQCard/AQCard";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "SelectTemplate",
    components: {
        AQButton,
        AQInput,
        AQCard
    },
    data() {
        return {
            searchTemplate: null
        };
    },
    computed: {
        ...mapGetters("smartContractDesigner", ["getAllTemplate"]),

        templates() {
            return this.getAllTemplate;
        },
        filteredTemplate() {
            const haveTemplate = !!this.searchTemplate;
            const lowerCaseSearchValue = haveTemplate ? this.searchTemplate.toLowerCase() : null;
            const templateFilter = element => element.name.toLowerCase().includes(lowerCaseSearchValue);

            return haveTemplate ? this.getAllTemplate.filter(templateFilter) : this.getAllTemplate;
        }
    },
    methods: {
        ...mapActions("smartContractDesigner", ["getTemplateSC"]),
        selectTemplate(object) {
            this.$emit("selectedTemplate", object);
        }
    },
    mounted() {
        if (!this.getAllTemplate) {
            this.getTemplateSC().then(() => {
                this.templates;
            });
        }
    }

};
